import React from 'react'

import * as Styled from '../Alternatives.styles'

const AlternativesHeadline = props => {
  const { hasProducts, headline } = props
  const headlineTag = <Styled.Headline>{headline}</Styled.Headline>
  const headlineHtml = hasProducts ? headlineTag : null
  return headlineHtml
}

export default AlternativesHeadline
